import moment from 'moment';
import React, {useEffect, useState} from 'react';
import { numberWithCommas } from '../../../../../Utils/NumberToComma';
import './fInvoice.css'
import LineItemModal from '../../ViewInvoice/India/LineItemModal';
import { get, post } from '../../../../../Model/Network/Config/Axios';
import { handleError, showToast } from '../../../../Common/fToast/ToastCallback';
import { LineItemCostAllocation } from '../../Submit/MultiSubmitInvoice/CostAllocation/LineItemCostAllocation';
import { useSelector } from 'react-redux';
import { ReadOnly } from '../../../../Common/fCard/ButtonOutline/ReadOnly';
import { ToggleSwitch2 } from '../../../../Common/fSwitch';

function Invoice(props){
    let {debitNote,total_amt,sgst,igst,total_tax,cgst,total_base,invoice_amount,roundOff,penalty,discountAmount,tds,status,categoryId,category,vendorID,tdsAtLineItem,isIndependentCreditNote,vendorAddress,vendorGstin,
        enableCostAllocation,
        costAllocationDone,
        tdsAutomationAtCreditNoteLineItem,attachment
    } = props.data;
    
    // Default currency is INR
    let {currency} = props;
    if(!currency) {
        currency = 'INR'
    }

    const [showCustomFormId, setShowCustomFormId] = useState(false);
    const [edit, setEdit] = useState(undefined)
    const [open,setOpen] = useState(undefined);
    const [previousType,setPreviousType] = useState(undefined);
    const [creditNotePreview,setCreditNotePreview] = useState(false)
    const {tenant} = useSelector(state=>state.auth.config);
     const [costAllocationForm, setCostAllocationForm] = useState([]);
    // const [previousType,setPreviousType] = useState(undefined);
   const hideGlField =['ANRCK','ANAROCK'].includes(tenant) && ['APPROVAL','TAXATION_APPROVAL'].includes(status)

    const handleLineItemUpdate = (reqBody) => {
        let { tds, ...rest } = reqBody;
        if (tdsAutomationAtCreditNoteLineItem && tds && tds.tdsMaster) {
            rest = {
                ...rest,
                tdsMaster: tds.tdsMaster,
            };
        } else {
            if (tds) {
                rest = {
                    ...rest,
                    ...tds,
                };
            }
        }             
        post(`vendor/vendor/creditNote/${props.CreditNoteId}/lineItem.update`,rest,(e,r)=>{
            if(r){
                props.reload();
                showToast({type:'success',message:'LineItem Updated SucessFully'})
                setEdit();
            }else{
                handleError(e);
            }
        })
    }

    useEffect(()=>{
        get(`vendor/costAllocation/getAllocations?referenceType=credit-note&referenceId=${props.CreditNoteId}`,(e,r)=>{
            if(r) {
                setPreviousType({
                    key:r.data.baseType,
                    value:r.data.baseType
                })
            }
        })
    },[])


    const findLabelFromKey=(formData,key)=>{
        if(!formData.length)    return key;
        const obj=formData.find((item)=>item.id===key);
        if(!obj)    return key;
        return obj.key;
    }

    const renderFiles = (file, index) => {
		if(file.endsWith('.pdf')){
			return <iframe onClick={()=>window.open(file,'_blank')} key={index} src={file} title='Preview' className='pointer mt1' style={{border: 'none', width:'100%', height: '100vh'}}/>
		}else{
			return <img onClick={()=>window.open(file,'_blank')} src={file} alt='Attachment' className='w-100 mt1 pointer'/>
		}
	}
    
    const getCostAllocationForm = () => {
        return new Promise((resolve, reject) => {
            get(`forms/invoice::item::costAllocation::${props.data.categoryId}`,(e,r)=>{
                if(r) {
                    setCostAllocationForm(r.forms);
                    resolve(r.forms);
                } else {
                    reject(e);
                }
            })
        })
    }


    const rednerTable = (item, index)=>{
        return(
            <div key={`entry-${index}`} style={{display: 'flex',alignItems:'center', justifyContent: 'space-evenly', margin: '15px 0px'}}>
                <div style={{width: '160px'}}>{item.desc}<br/>Code: {item.hsn} <br /> Service : {item.service} 
                {item.tds && (
                    <div>
                        Tds Amount : {item.tds.tdsAmount?item.tds.tdsAmount.toFixed(2):''} <br></br>
                        Tds Code : {item.tds.tdsCode || '-'} <br></br>
                        Tds Rate : {item.tds.tdsRate || '-'} <br></br>
                        Tds Desc : {(item.tds.tdsDesc) || '-'} <br></br>
                    </div>
                )}
                {(item && item.glCode)?
                    <div>
                        GL Code : {item.glCode} <br></br>
                    </div>
                :null}
                <br/>
                {item.forms && item.forms.length > 0 ? (
					<div>
				      <div 
					     style={{paddingTop:5,cursor: 'pointer'}}
					      onClick={() => setShowCustomFormId(showCustomFormId && showCustomFormId === item.id ? false : item.id)}>
						<h4>
						{showCustomFormId === item.id ? 'Hide': 'Show'}Custom form</h4>
				    	</div> <br />
					  {showCustomFormId === item.id &&
						item.forms.map(([key,value]) => (
						<div style={{ flexDirection: 'column' }} key={key}>
            	       	    <p style={{fontWeight:250,color:'grey'}}> {findLabelFromKey(item.formData,key)}: <span style={{fontWeight:500,color:'black'}}>{value}</span></p>
						 <br />
						</div>
						))}
					</div>
				    ) : null}
                <br></br>
                </div>
                {
                    props.data.costAllocationDone || (props.data.enableCostAllocation && props.approvalStatus()) ?
                    <div style={{width:100,display:'flex'}}>
                         <div style={{
                             backgroundColor: "var(--green-color)",
                             color: "#fff",
                             height: 20,
                             width: 20,
                             borderRadius: "50%",
                             fontWeight: "bold",
                             cursor: "pointer",
                             fontSize: 16,
                             display: "flex",
                             alignItems: "center",
                             justifyContent: "center",
                             marginRight:5
                             }} onClick={()=>{
                                setOpen(index+1)
                            }}>
                             +
                         </div>
                        
                        {
                            item.isAllocationAvailable ?
                            <div onClick={()=>{
                                setOpen(index+1)
                            }} style={{cursor:'pointer',color:'var(--primary-color)',marginLeft:5}}>View</div>:<div>-</div>
                        }
                    </div>
                    :null

                }
                <div style={{width: '100px',}}> {item.price ?numberWithCommas(item.price.toFixed(2)):item.price}</div>
                <div style={{width: '100px',}}> {item.original_qtty.toFixed(2)}</div>
                {debitNote?<div style={{width: '100px',}}> {item.debitQty}</div>:null}
                <div style={{width: '100px',}}> {item.base_amt ?numberWithCommas(item.base_amt.toFixed(2)):item.base_amt}</div>
                {currency==="INR"?<div style={{width: '100px'}}> {item.cessAmount ?numberWithCommas(item.cessAmount.toFixed(2)):0}</div>:null}
                <div style={{width: '100px'}}> {item.tax_amt ?numberWithCommas(item.tax_amt.toFixed(2)):numberWithCommas(item.tax_amt)}</div>
                <div style={{width: '100px', textAlign: 'right'}}> {item.amount ?numberWithCommas(item.amount.toFixed(2)):numberWithCommas(item.amount)}</div>
                <ReadOnly type={((props && props.data && props.data.status === 'TAXATION_APPROVAL'))?"Taxation Stage":undefined}>
                {isIndependentCreditNote && (props.approvalStatus && props.approvalStatus()) && <div style={{ width: '100px', textAlign: 'right' }}>
                    <span style={{ padding: 5, color: 'var(--primary-color)', cursor: 'pointer' }}
                        onClick={() => setEdit(item)}>
                        EDIT
                    </span>
                </div>}
                </ReadOnly>
            </div>
        )
    }
    
    let partial = 0;

    props.data.allSettlement.forEach(val=>{
         if(val.transferred) {
            partial = partial+val.amount
         }
    })
// console.log("previousType",previousType);


 return(
        <div className='FadeRight-Effect' style={{width: '100%', fontSize: '12px'}}>
        <ToggleSwitch2 style={{ justifyContent: 'flex-start' }} checked={creditNotePreview} callback={setCreditNotePreview}  size="S" label="View Original Credit Note" />
        {creditNotePreview ? (
            <div style={{ marginTop: 10 }}>
								  {attachment && attachment.map(renderFiles)}
			</div>) : 

       (  
        <>
          <div style={{textAlign: 'center', fontSize: '22px', fontWeight: 'bold'}}>View Credit Note</div>
            {
              
                props.data.discount?
                    <p style={{
                        top:10,
                        left:0,
                        padding:'12px 30px',
                        position:'absolute',
                        background:"green",
                        color:'var(--white-color)',
                        fontSize:11
                    }}>
                        Discounted at {props.data.discount} %
                    </p>:undefined
            }
            {
              
              props.data.rcVendor?
                  <p style={{
                      top:40,
                      left:0,
                      padding:'12px 30px',
                      position:'absolute',
                      background:'var(--primary-color)',
                      color:'var(--white-color)',
                      fontSize:11
                  }}>
                      RCM Invoice
                  </p>:undefined
          }
        <div style={{border: '1px solid var(--border-color)', padding: '20px', borderRadius: '15px', marginTop: '30px'}}>
            <div style={{display: 'flex', justifyContent: 'space-between'}}>
                <div>
                    <b>Vendor</b><br/>
                    Name: {props.data.vendor}<br/>
                    TradeName: {props.data.tradeName||'NA'}<br/>
                    Vendor Code : {props.data.vendor_code} <br/>
                    Email: {props.data.email||"NA"}<br/>
                    GSTIN: {vendorGstin?vendorGstin:props.data.vendor_id||'NA'}<br/>
                    Address: {vendorAddress && vendorAddress.address} <br></br>
                    { vendorAddress && vendorAddress.state} {vendorAddress && vendorAddress.pincode} <br></br>
                </div>
                <div style={{textAlign: 'right'}}>
                Date: {moment(props.data.date).format('DD-MM-YYYY')}<br/>
                {props.data.due?<>Due Date: {moment(props.data.due).format('DD-MM-YYYY')}<br/></>:<></>}
                Credit Note Number : {props.data.bill_number}<br/>
                </div>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-between', marginTop: '20px'}}>
                <div style={{paddingRight: '20px'}}>
                    <b>Billing Address</b><br/>
                    {props.data.bill_to.name?<span>{props.data.bill_to.name}<br></br></span>:null}
                    {props.data.bill_to.title?<span>{props.data.bill_to.title}<br></br></span>:null}
                    {props.data.bill_to.registeredName?<span>{props.data.bill_to.registeredName}<br></br></span>:null}
                    {props.data.bill_add}<br/>
                    {props.data.bill_to.gstin?<span>{props.data.bill_to.gstin}<br></br></span>:null}

                </div>
                <div style={{textAlign: 'right', paddingLeft: '20px'}}>
                    <b>Shipping Address</b><br/>
                    {props.data.ship_to.name?<span>{props.data.ship_to.name}<br></br></span>:null}
                    {props.data.ship_to.title?<span>{props.data.ship_to.title}<br></br></span>:null}
                    {props.data.ship_to.registeredName?<span>{props.data.ship_to.registeredName}<br></br></span>:null}
                    {props.data.ship_add}<br></br>
                    {props.data.ship_to.gstin?<span>{props.data.ship_to.gstin}<br></br></span>:null}
                </div>
            </div>
        </div>

        <div style={{display: 'flex', justifyContent: 'space-evenly', marginTop: '30px', fontWeight: 'bold', paddingBottom: '10px', borderBottom: '1px solid var(--border-color)'}}>
            <div style={{width: '160px'}}>Desciption</div>
            {
                enableCostAllocation && props.approvalStatus() ?
                <div style={{width:100}}>
                    Allocation
                </div>
                :null
            }
            {
                costAllocationDone ?
                <div style={{width:'100px'}}>
                    Allocation
                </div>
                :null
            }
            <div style={{width: '100px',}}>Price/Per Unit</div>
            <div style={{width: '100px',}}>Qty</div>
            {debitNote?<div style={{width: '100px',}}>Debit Qty</div>:null}
            <div style={{width: '100px',}}>Base Amt</div>
            {currency==="INR"?<div style={{width: '100px',}}>Cess Amt</div>:null}
            <div style={{width: '100px'}}>Tax Amt</div>
            <div style={{width: '100px', textAlign: 'right'}}>{`Amount (${currency})`}</div>
            {isIndependentCreditNote && (props.approvalStatus && props.approvalStatus()) && <div style={{width: '100px', textAlign: 'right'}}>Action</div>}

        </div>

       {
           props.data.table.map(rednerTable)
       }
       {currency==="INR"?<>
            <div className='invoice-taxes'>
                    <div className='wrap'>
                        <div>SGST / UTGST: </div>
                        <div> {numberWithCommas(sgst.toFixed(3))}</div>
                    </div>
                </div>
                <div className='invoice-taxes'>
                    <div className='wrap'>
                        <div>CGST: </div>
                        <div> {numberWithCommas(cgst.toFixed(3))}</div>
                    </div>
                </div>
                <div className='invoice-taxes'>
                    <div className='wrap'>
                        <div>IGST: </div>
                        <div> {igst ?numberWithCommas(igst.toFixed(2)):numberWithCommas(igst)}</div>
                    </div>
                </div>
        </>:null}

        <div className='invoice-taxes'>
            <div className='wrap'>
                <div>Base Amt: </div>
                <div> {numberWithCommas(total_base.toFixed(2))}</div>
            </div>
        </div>
       {roundOff? 
        <div className='invoice-taxes'>
            <div className='wrap'>
                <div>RoundOff: </div>
                <div> {numberWithCommas(roundOff.toFixed(2))}</div>
            </div>
        </div>:null
        }
         <div className='invoice-taxes'>
            <div className='wrap'>
                <div>Discount: </div>
                <div> {numberWithCommas(discountAmount.toFixed(2))}</div>
            </div>
        </div>
         <div className='invoice-taxes'>
            <div className='wrap'>
                <div>Penalty: </div>
                <div> {numberWithCommas(penalty.toFixed(2))}</div>
            </div>
        </div>
        <div className='invoice-taxes' style={{fontWeight: 'bold'}}>
            <div className='wrap'>
                <div>Tax Amt: </div>
                <div> {numberWithCommas(total_tax.toFixed(2))}</div>
            </div>
        </div>
        <div className='invoice-taxes' style={{fontWeight: 'bold'}}>
            <div className='wrap'>
                <div>TDS: </div>
                <div> {numberWithCommas(tds)}</div>
            </div>
        </div>

        <div style={{display: 'flex', padding: '10px 0px', fontWeight: 'bold', borderTop: '1px solid var(--border-color)', borderBottom: '1px solid var(--border-color)'}}>
            <div style={{flexGrow: 1}}>Total Credit Amount: </div>
            <div style={{width: '100px', textAlign: 'right'}}> {numberWithCommas((total_amt+penalty-tds).toFixed(2))}</div>
        </div>

        {invoice_amount && 
            <div style={{ display: 'flex', padding: '10px 0px', fontWeight: 'bold', borderTop: '1px solid var(--border-color)', borderBottom: '1px solid var(--border-color)' }}>
                <div style={{ flexGrow: 1 }}>Original Invoice Payable Amount: </div>
                <div style={{ width: '100px', textAlign: 'right' }}> {numberWithCommas((invoice_amount).toFixed(2))}</div>
            </div>
        }
        <div style={{ display: 'flex', padding: '20px 0px', fontWeight: 'bold'}}/>
        {
		open && previousType && (props.data.costAllocationDone ? true: !props.onlyLineItemCostAllocationAllowed)?
		<LineItemCostAllocation
			lineItems={[...props.data.table]}
			index={open}
			view={props.approvalStatus && props.approvalStatus()?false:true}
            edit={props.approvalStatus && props.approvalStatus()}
            previousType={previousType}
            invoiceTotalAmount={total_amt}
			close={()=>{
				setOpen(false);
			}}
            categoryId={props.data.categoryId}
            init={async (data)=>{

                let lineItemObject = {};
                props.data.table.filter((_,index)=>(index!==open-1)).forEach(i=>{
                    lineItemObject[i.id] = i.costAllocations
                })

                data.costAllocation.costAllocationAtItems = {
                    ...data.costAllocation.costAllocationAtItems,
                    ...lineItemObject
                }
              const processCostAllocationItems = async (costAllocationAtItems) => {
                    // Get forms if not already loaded
                    let forms = costAllocationForm;
                    if (!forms || forms.length === 0) {
                        try {
                            forms = await getCostAllocationForm();
                        } catch (e) {
                            console.error("Error fetching cost allocation forms:", e);
                            return costAllocationAtItems;
                        }
                    }
                    const findFormByFieldId = (fieldId) => {
                        return forms.find(form => {
                            if (!form.name) return false;
                            return String(form.name) === String(fieldId) || Number(form.name) === Number(fieldId);
                        });
                    };

                    // Process each allocation item
                    const processedItems = {};
                    Object.keys(costAllocationAtItems).forEach(key => {
                        const allocations = costAllocationAtItems[key];
                        if (!Array.isArray(allocations)) {
                            processedItems[key] = allocations;
                            return;
                        }
                        processedItems[key] = allocations.map(item => {
                            if (item.customForms && !item.formData) {
                                const transformedCustomForms = {};
                                Object.keys(item.customForms).forEach(fieldIdKey => {
                                    const matchedForm = findFormByFieldId(fieldIdKey);
                                    if (matchedForm && matchedForm.id) {
                                        transformedCustomForms[matchedForm.id] = item.customForms[fieldIdKey];
                                    } else {
                                        transformedCustomForms[fieldIdKey] = item.customForms[fieldIdKey];
                                    }
                                });
                                return {
                                    ...item,
                                    customForms: transformedCustomForms
                                };
                            }
                            return item;
                        });
                    });

                    return processedItems;
                };
                
                // Process the costAllocationAtItems
                data.costAllocation.costAllocationAtItems = await processCostAllocationItems(data.costAllocation.costAllocationAtItems);

                post(`/vendor/vendor/creditNote/${props.CreditNoteId}/costAllocation.update`,data,(e,r)=>{
                    if(r) {
                        showToast({
                            type:'success',
                            message:'Cost Allocation Update Successfully'
                        })
                        setOpen(false);
                        props.init();
                    } else {
                        showToast({
                            type:'error',
                            message:e.data.message
                        })
                    }
                })
            }}
		/>
		:null
	  }
        {
		open && !previousType && !props.onlyLineItemCostAllocationAllowed ?
		<LineItemCostAllocation
			lineItems={[...props.data.table]}
			index={open}
			view={false}
            edit={false}
            categoryId={props.data.categoryId}
            previousType={previousType}
            invoiceTotalAmount={total_amt}
			close={()=>{
				setOpen(false);
			}}
            updateLineItems={(items, type) => {
                setPreviousType(type);
                props.updateAllocation(items,type,open-1);
              }}

		/>
		:null
	  }
        {
		open && (props.onlyLineItemCostAllocationAllowed && !props.data.costAllocationDone)?
		<LineItemCostAllocation
			lineItems={[...props.data.table]}
			index={open}
			view={false}
            edit={false}
            categoryId={props.data.categoryId}
            previousType={previousType}
            invoiceTotalAmount={total_amt}
			close={()=>{
				setOpen(false);
			}}
            updateLineItems={(items, type) => {
                setPreviousType(type);
                props.updateAllocation(items,type,open-1);
              }}

		/>
		:null
	  }
        </>)}
         {
             edit &&
             <LineItemModal
                 edit={edit}
                 currency={currency}
                 categoryId={categoryId}
                 updateLineItemCustomForm={(key,value,itemId) => {
                    post(`/vendor/vendor/creditNote/edit/finance.item.form/${props.CreditNoteId}`, { forms:{[key]:value},itemId}, (e, r) => {
                        if (r) {
                            props.reload();
                            showToast({
                                type: 'success',
                                message: 'Value Updated Sucessfully'
                            })
                        } else if (e) {
                            handleError(e);
                        }
                    });
                }}
                 onSave={handleLineItemUpdate}
                 tdsAtLineItem={tdsAtLineItem}
                 tdsAtLineItemInContract={props.tdsAtLineItemInContract}
                 vendorId={vendorID}
                 close={() => setEdit(undefined)}
                 category={category}
                 contractId={props.data.contractId}
                 isCreditNote={true}
                 tdsSlabs={(props && props.tdsSlabs)?props.tdsSlabs:undefined}
                 vendor={(props && props.vendor)?props.vendor:undefined}
                 hideGlField={hideGlField}
                 tdsAutomationAtCreditNoteLineItem={tdsAutomationAtCreditNoteLineItem}
                 
             />
         }
       
    </div>
 )
}



export default Invoice;
